import(/* webpackMode: "eager" */ "/root/alkindivv.site/app/error.tsx");
